import { ClassificationDetection } from '../snapshot/classificationDetection';
import { StoreCustomerTicket } from '../ticket/ticket';
import { CustomerSessionInfo, SessionImageDetectionConfirmation, SessionImageDetectionImage } from './session';
import { SessionLocation } from './sessionLocation';
import { SessionMonitorSessionDeviceMetadata } from './sessionMonitor';
import z from 'zod';

export const SessionSoftwareTara = z.object({
    createdOn: z.string().nullish(),
    weight: z.int().nullish(),
    actualWeight: z.int().nullish(),
    expectedWeight: z.int().nullish(),
});
export type SessionSoftwareTara = z.infer<typeof SessionSoftwareTara>;

export const SessionWeightDeviation = z.object({
    actualWeight: z.int().nullish(),
    expectedWeight: z.int().nullish(),
    withinThreshold: z.boolean().nullish(),
    createdOn: z.string().nullish(),
});
export type SessionWeightDeviation = z.infer<typeof SessionWeightDeviation>;

export const SessionScaleTrigger = z.object({
    createdOn: z.coerce.date().nullish(),
    actualWeight: z.int().nullish(),
    expectedWeight: z.int().nullish(),
    scaleDelta: z.int().nullish(),
    expectedDelta: z.int().nullish(),
    weightAdjustments: z
        .object({
            createdOn: z.string().nullish(),
            basketItemGuid: z.string(),
            adjustedTotalWeight: z.int().nullish(),
            changeAmount: z.int().nullish(),
            itemId: z.string().nullish(),
            singleWeight: z.int().nullish(),
            images: z.string().array().nullish(),
        })
        .array()
        .nullish(),
});
export type SessionScaleTrigger = z.infer<typeof SessionScaleTrigger>;

export const SessionActiveDevice = z.object({
    hasTicket: z.boolean().nullish(),
    isDemoModeOn: z.boolean().nullish(),
    isMobile: z.boolean().nullish(),
    isSessionOpen: z.boolean().nullish(),
    loginType: z.string().nullish(),
    sessionGuid: z.string().nullish(),
    storeGuid: z.string().nullish(),
    tenant: z.string().nullish(),
    deviceId: z.string().nullish(),
    targetId: z.string().nullish(),
    tickets: StoreCustomerTicket.array().nullish(),
    location: SessionLocation.nullish(),
    startedOn: z.coerce.date().nullish(),
    actualWeight: z.int().nullish(),
    expectedWeight: z.int().nullish(),
    customer: CustomerSessionInfo.nullish(),
    taras: SessionSoftwareTara.array().nullish(),
    scaleTriggers: SessionScaleTrigger.array().nullish(),
    weightDeviations: SessionWeightDeviation.array().nullish(),
    targetGuid: z.string().nullish(),
    sessionStartImages: z.string().array().nullish(),
    sessionEndImages: z.string().array().nullish(),
    deviceMetadata: SessionMonitorSessionDeviceMetadata.nullish(),
    isSuspicious: z.boolean().nullish(),
    isAnonymous: z.boolean().nullish(),
    imageDetections: z
        .record(
            z.string(),
            z.object({
                detectionId: z.string().nullish(),
                detection: ClassificationDetection.nullish(),
                image: SessionImageDetectionImage.nullish(),
                needsConfirmation: z.boolean().nullish(),
            }),
        )
        .nullish(),
    imageDetectionConfirmations: z.record(z.string(), SessionImageDetectionConfirmation).nullish(),
    sessionModifiedOn: z.coerce.date().nullish(),
    total: z.int().nullish(),
});
export type SessionActiveDevice = z.infer<typeof SessionActiveDevice>;
